<template>
    <v-row no-gutters class="fill-height">
        <!-- // * LEFT PANEL -->
        <v-col cols="12">
            <!-- // * CONTENT TITLE (GENERIC) -->
            <!-- <v-row class="contenttitle grey lighten-2 white--text py-4 mx-0 pl-4 pr-2 d-flex align-center white">
                <app-text category="content-title">
                    <div class="d-flex align-center">
                        <span class="pl-2 d-inline-block text-truncate">{{ form.name }} </span>
                    </div>
                </app-text>
                <v-spacer></v-spacer>
            </v-row> -->

            <!--Body-->
            <div>
                    <!--Counters | Form | Register-->
                    <!-- // * FORM -->  
                    <v-form ref="form">
                        <v-row class="mt-2 px-2" no-gutters>
                            <!--Duration-->
                            <!--Counters-->
                            <div class="frcr-counter-container mx-1">
                                <app-text class="grey--text" category="tab-title">{{ site.siteName }} Live Roll Call</app-text>
                            
                                <v-spacer />
                                <!--In-->
                                <div class="ffrcr-counter" width="20">
                                    <app-text class="grey--text" category="text-small">IN</app-text>
                                    <app-text class="grey--text" category="text-default-bold"> {{ computedUsersSwappedIn }} </app-text>
                                </div>

                                <v-divider vertical/>

                                <!--Out-->
                                <div class="ffrcr-counter" width="20">
                                    <app-text class="grey--text" category="text-small">OUT</app-text>
                                    <app-text class="grey--text" category="text-default-bold"> {{ computedUsersSwappedOut }} </app-text>
                                </div>

                                <v-divider vertical/>

                                <!--Total-->
                                <div class="ffrcr-counter" width="40">
                                    <app-text class="grey--text" category="text-small">TOTAL</app-text>
                                    <app-text class="grey--text" category="text-default-bold"> {{ computedUsersTotal }} </app-text>
                                </div>

                            </div>

                        </v-row>

                    </v-form>

                    <!--User list-->
                    <div v-if="computedUsers.length !== 0" class="frcr-grid px-3 ">
                        <v-row class="align-center">
                            <v-col cols="12" class="">
                                <v-carousel cycle interval="100000" height="100%" hide-delimiters  class="" :show-arrows="false" v-model="model">
                                    <!-- <template v-slot:prev="{ on, attrs }">
                                        <v-icon
                                            x-large
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                        >icons8-back</v-icon>
                                    </template>
                                    <template v-slot:next="{ on, attrs }">
                                        <v-icon
                                            x-large
                                            color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                        >icons8-forward</v-icon>
                                    </template> -->
                                    <v-carousel-item v-for="(slide, i) in numberOfPages" :key="i">
                                        <div class="frcr-grid">
                                            <div v-for="(user, index) in pagedUsers(slide)" :key="index">

                                                <fireRollCallUserCard :user="user"/>

                                            </div>
                                        </div>
                                    </v-carousel-item>
                                </v-carousel>
                            </v-col>
                        </v-row>
                    </div>
                    <!-- <pre>Number of Pages: {{ numberOfPages }}</pre> -->
                    <!-- <pre>Site: {{ site }}</pre>
                    <pre>Computed Users: {{ computedUsers }}</pre>
                    <pre>Users Data: {{ usersData }}</pre> -->
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: "fireRollCall",
    data: () => ({
        //* PAGE DETAILS   
        collection: 'fireRollCall',
        collectionTitle: 'FireRollCall',
        collectionItem: 'fireRollCall',
        
        errors: {
            title: false,
            type: false,
            notes: false,
        },
        form: {
            id: '',
            name: '',
            site: '',
            type: '',
            notes: '',
            timeTaken: 0,
            checkedUsers: [],

            modifiedDateTime: '',
            modifiedUserData: '',
        },
        site: {},
        usersData: [],
        swappLogsCollectionData: [],
        usersCollectionData: [],

        formReadOnly: false,
        formMode: 'New',
        formBackground: 'grey lighten-3',
        tabs: '',

        rules: [],


        model: '',

        timeInterval: null,
    }),
    // * COMPUTED
    computed: {
        ...mapGetters({
            GET_openItem: 'GET_openFireRollCall',
            GET_help: 'GET_help',
            GET_confirmBoxResult: 'confirmBox_store/GET_confirmBoxResult', // Get Confirm Box Result
        }),

        numberOfPages() {
            return Math.ceil(this.computedUsers.length / 25);
        },


        computedUsers() {
            const t = this
            let users = t.usersData
            // console.log('computing users ' + t.usersData.length)

            // Filter by Site
            users = users.filter(function(item) {
                if (item.swappStatus === 0) {
                    var timeNow = t.$moment().format('X')
                    var timeMinus2 = t.$moment().subtract(15, 'minutes').format('X')
                    return item.swappedTime > timeMinus2
                } else if (item.swappStatus === 1) {
                    return item
                }
            })
            
            // Sort by SWAPP status, then alphabetically
            users.sort((a, b) => {
                // Swapp - in first
                if (a.swappStatus < b.swappStatus) return 1
                if (a.swappStatus > b.swappStatus) return -1
                // UserName - a-z
                if (a.userName > b.userName) return 1
                if (a.userName < b.userName) return -1
            })

            return users
        },
        computedUsersSwappedIn() {
            const t = this

            return t.computedUsers.filter(user => user.swappStatus === 1).length
        },
        computedUsersSwappedOut() {
            const t = this

            return t.computedUsers.filter(user => user.swappStatus === 0).length
        },
        computedUsersTotal() {
            const t = this

            return t.computedUsers.length
        },
    },
    //* WATCH
    watch: {

    },
    //* METHODS
    methods: {
        ...mapActions({'ACT_openItem': 'ACT_openFireRollCall'}),           
        // UPDATE BREADCRUMBS
        updateBreadcrumbs() {
            var t = this;
            var breadcrumbs = [];
            breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
            if (t.GET_openItem.process === 'New') {
                breadcrumbs.push ({ name: `New ${t.collectionItemTitle}`, path: `/${t.collection}`}) // Set a Secondary Path
            } else {
                breadcrumbs.push ({ name: `${this.GET_openItem.data[t.collectionItem + 'Name']}`, path: `/${t.collection}/${this.GET_openItem.data.id}`}) // Set a Secondary Path
            }
            this.MIX_breadcrumbs(breadcrumbs);
        },
        // GET NOTICES SNAPSHOT METHOD
        getTableData: async function () {
            var t = this;
            var collection = t.$firebase.db.collection('users').where('lastSite.siteId', '==', t.site.id)
            t.customWhere = [];
            // console.log('getting users')
            
            if (JSON.stringify(t.customWhere) !== '[]') {
                for (var i = 0; i < t.customWhere.length; i++) {
                    var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                    collection = collection.where(query.field, query.operator, query.value)   
                }
            }

            collection.onSnapshot(function(querySnapshot) {
                t.usersData = [];
                querySnapshot.forEach(function(doc) {
                    var document = doc.data()
                    document.id = doc.id;
                    if (!document.hasOwnProperty('delete')) {
                        t.usersData.push(document);
                    } else if (t.showDeleted) {
                        t.usersData.push(document);
                    } else {
                        // Do not Show Concern
                    }
                });
                // console.log("usersData = " + JSON.stringify(t.usersData, null, 2))
            });
            // t.matchUsersAndSwappLogs()
            return;
        },
        // GET SWAPP LOGS
        getSwappLogs: async function() {
            var t = this;
            var collection = t.$firebase.db.collection('swappLogs')
            t.customWhere = [];

            if (JSON.stringify(t.customWhere) !== '[]') {
                for (var i = 0; i < t.customWhere.length; i++) {
                    var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                    collection = collection.where(query.field, query.operator, query.value)   
                }
            }

            collection.onSnapshot(function(querySnapshot) {
                t.swappData = [];
                querySnapshot.forEach(function(doc) {
                    var document = doc.data()
                    document.id = doc.id;
                    if (!document.hasOwnProperty('delete')) {
                        t.swappData.push(document);
                    } else if (t.showDeleted) {
                        t.swappData.push(document);
                    } else {

                    }
                })
            })
        },
        matchUsersAndSwappLogs() {
            var t = this;
            // console.log(JSON.stringify(t.usersData, null, 2))
            t.usersData.forEach(user => {
                let userSwappLog = t.swappData.filter(function(item) {
                    return item.swappedUser === user.id 
                })
                userSwappLog = userSwappLog.sort((a,b) => {
                    return a.modifiedDateTime < b.modifiedDateTime ? 1 : -1
                })
                user.lastSwappDateTime = userSwappLog.length ? userSwappLog[0].modifiedDateTime : 0
                // console.log(JSON.stringify(user.lastSwappDateTime, null, 2))
            })
            return t.usersData.filter(user => t.$moment(Number(user.lastSwappDateTime)).format('DD-MM-YYYY') === t.$moment().format('DD-MM-YYYY'))
        },
        pagedUsers(slideNo) {
            var t = this;
            const start = (slideNo - 1) * 25
            const end = start + 25
            return t.computedUsers.slice(start, end)
        },



    },
    async mounted() {
        var t = this;
        //* ITEM RELATED MOUNTED
        // var openItem = await t.GET_openItem; // Get open project data
        // t.formMode = openItem.process; // Show form in View Mode
        // if (openItem.process === 'New') {
        //     t.formReadOnly = false; // Make form editable
        //     t.formBackground = 'white';
        // } else {
        //     t.form = openItem.data; // Update the Form with the Open Project Details
        //     t.formReadOnly = true;
        //     t.formBackground = 'grey lighten-3';
        // }

        // if (openItem.popup === false) { t.updateBreadcrumbs() } // Update Breadcrumbs in Title

        var siteId = ''

        if (this.$route.params.id != null && this.$route.params.id != undefined ) {
            siteId = t.$route.params.id
            var siteData = await t.MIX_readDocumentById('sites', siteId)
            if (siteData.code == 1) {
                t.site = siteData.data
            }
        }

        await t.getTableData()

        // refresh every 2 minutes
        this.timeInterval = setTimeout(function() {
            t.getTableData()
        }, 120000)

    },
    beforeDestroy() {
        clearInterval(this.timeInterval)
    },
}
</script>


<style scoped>
  .disabled >>> .v-input__slot::before {
        border-style: none !important;
    }
.frc-icon {
    border-radius: 50%;
    padding: 8px;
}

.frc-icon-edit-active {
    background: orange;
    border-radius: 50%;
    color: white;
    padding: 8px;
}
.frcr-counter-container {
    display: flex;
    align-self: center;
    justify-content: center;
    grid-gap: 32px;

    background: rgb(238, 238, 238);
    border-radius: 5px;
    margin-top: 16px;
    padding: 8px 16px;
    width: calc(100%);
    z-index: 1;
}

.ffrcr-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.frc-userList {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    grid-gap: 16px;

    background: rgb(238, 238, 238);
    border-radius: 5px;
    margin-top: 16px;
    padding: 16px;
}
</style>
